const education = [
    {   
        companyIcon: 'facisa.png', 
        role: 'Tecnólogo em Jogos Digitais', 
        companyName: 'Unifacisa - Centro Universitário ', 
        companyLocation: 'Paraíba, Brasil', 
        year: 'Fevereiro 2016 - Julho 2020'
    },
    { 
        companyIcon: 'if.png', 
        role: 'Ensino Médio-Técnico em Manutenção e Suporte em TI', 
        companyName: 'Instituto Federal de Educação, Ciência e Tecnologia ', 
        companyLocation: 'Paraíba, Brasil', 
        year: 'Fevereiro 2009 - Julho 2013'
    },
    
  ];
  
  export default education;